import React, { useState } from "react";

const imageList = [
  "/resort.jpg",
  "/gal1.jpg",
  "/gal2.jpg",
  "/gal3.jpg",
  "/gal4.jpg",
  "/gal5.jpg",
  "/gal6.jpg",
  "/gal7.jpg",
  "/image2.jpg",
  "/gal9.jpg",
  "/image1.jpg",
  "/image3.jpg",
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [likedImages, setLikedImages] = useState(new Set());

  const handleImageClick = (src, index) => {
    setSelectedImage({ src, index });
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const toggleLike = (index) => {
    const newLikedImages = new Set(likedImages);
    if (newLikedImages.has(index)) {
      newLikedImages.delete(index);
    } else {
      newLikedImages.add(index);
    }
    setLikedImages(newLikedImages);
  };

  const navigateImage = (direction) => {
    if (!selectedImage) return;
    const newIndex = direction === 'next' 
      ? (selectedImage.index + 1) % imageList.length
      : (selectedImage.index - 1 + imageList.length) % imageList.length;
    setSelectedImage({ src: imageList[newIndex], index: newIndex });
  };

  return (
    <div style={styles.container}>
      <div dangerouslySetInnerHTML={{ __html: hoverStyles }} />
      {/* Hero Section */}
      <div style={styles.hero}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent}>
          <div style={styles.badge}>
            <span style={styles.badgeText}>✨ Sangam Resort & Banquet</span>
          </div>
          <h1 style={styles.title}>Photo Gallery</h1>
          <p style={styles.subtitle}>
            Discover the beauty and memorable moments captured at our stunning resort
          </p>
        </div>
      </div>

      {/* Gallery Grid */}
      <div style={styles.galleryContainer}>
        <div style={styles.galleryGrid} className="gallery-grid">
          {imageList.map((src, idx) => (
            <div
              key={idx}
              style={styles.galleryItem}
              className="gallery-item"
              onClick={() => handleImageClick(src, idx)}
            >
              <div style={styles.imageContainer}>
                <img
                  src={src}
                  alt={`Gallery image ${idx + 1}`}
                  style={styles.image}
                />
              </div>
              
              <div style={styles.overlay} className="overlay">
                <div style={styles.overlayContent}>
                  <div style={styles.actionButtons}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleLike(idx);
                      }}
                      style={{
                        ...styles.actionButton,
                        color: likedImages.has(idx) ? '#ef4444' : '#ffffff'
                      }}
                      className="action-button"
                    >
                      {likedImages.has(idx) ? '❤️' : '🤍'}
                    </button>
                    <button style={styles.actionButton} className="action-button">
                      📤
                    </button>
                  </div>
                  <div style={styles.viewButton}>
                    <span style={styles.viewText}>🔍 View</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeModal}
              style={styles.closeButton}
              className="close-button"
            >
              ✕
            </button>

            <button
              onClick={() => navigateImage('prev')}
              style={styles.navButton}
              className="nav-button"
            >
              ‹
            </button>
            <button
              onClick={() => navigateImage('next')}
              style={{...styles.navButton, right: '20px'}}
              className="nav-button"
            >
              ›
            </button>

            <img
              src={selectedImage.src}
              alt={`Gallery image ${selectedImage.index + 1}`}
              style={styles.modalImage}
            />

            <div style={styles.modalInfo}>
              <div style={styles.modalInfoContent}>
                <span style={styles.imageCounter}>
                  Image {selectedImage.index + 1} of {imageList.length}
                </span>
                <div style={styles.modalActions}>
                  <button
                    onClick={() => toggleLike(selectedImage.index)}
                    style={{
                      ...styles.modalActionButton,
                      color: likedImages.has(selectedImage.index) ? '#ef4444' : '#ffffff'
                    }}
                    className="modal-action-button"
                  >
                    {likedImages.has(selectedImage.index) ? '❤️' : '🤍'}
                  </button>
                  <button style={styles.modalActionButton} className="modal-action-button">
                    📤
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  hero: {
    position: 'relative',
    padding: '80px 16px 48px',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(90deg, rgba(34, 197, 94, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)',
    backdropFilter: 'blur(60px)',
  },
  heroContent: {
    position: 'relative',
    maxWidth: '1024px',
    margin: '0 auto',
    textAlign: 'center',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '8px 16px',
    borderRadius: '50px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(229, 231, 235, 1)',
    marginBottom: '24px',
  },
  badgeText: {
    color: '#059669',
    fontSize: '14px',
    fontWeight: '500',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '700',
    background: 'linear-gradient(90deg, #1f2937 0%, #374151 50%, #4b5563 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '16px',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: '1.25rem',
    color: '#6b7280',
    maxWidth: '512px',
    margin: '0 auto',
    lineHeight: 1.6,
  },
  galleryContainer: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 16px 64px',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
  },
  galleryItem: {
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateY(0px)',
    borderRadius: '12px',
  },
  imageContainer: {
    aspectRatio: '1',
    overflow: 'hidden',
    borderRadius: '12px',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 50%)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    borderRadius: '12px',
  },
  overlayContent: {
    position: 'absolute',
    bottom: '16px',
    left: '16px',
    right: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
  },
  actionButton: {
    padding: '8px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(8px)',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    fontSize: '16px',
  },
  viewButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  viewText: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '500',
  },
  modal: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    backdropFilter: 'blur(8px)',
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  modalContent: {
    position: 'relative',
    maxWidth: '1024px',
    maxHeight: '90vh',
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    zIndex: 10,
    padding: '8px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '24px',
    transition: 'background-color 0.3s ease',
  },
  navButton: {
    position: 'absolute',
    left: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    padding: '12px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '24px',
    transition: 'background-color 0.3s ease',
  },
  modalImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '8px',
  },
  modalInfo: {
    position: 'absolute',
    bottom: '16px',
    left: '16px',
    right: '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(8px)',
    borderRadius: '8px',
    padding: '16px',
  },
  modalInfoContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#ffffff',
  },
  imageCounter: {
    fontSize: '14px',
    fontWeight: '500',
  },
  modalActions: {
    display: 'flex',
    gap: '8px',
  },
  modalActionButton: {
    padding: '8px',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    fontSize: '20px',
  },
};

// Enhanced responsive styles
const hoverStyles = `
  <style>
    .gallery-item:hover {
      transform: translateY(-8px) !important;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
    }
    .gallery-item:hover img {
      transform: scale(1.1) !important;
    }
    .gallery-item:hover .overlay {
      opacity: 1 !important;
    }
    .action-button:hover,
    .modal-action-button:hover {
      background-color: rgba(255, 255, 255, 0.3) !important;
    }
    .close-button:hover,
    .nav-button:hover {
      background-color: rgba(255, 255, 255, 0.2) !important;
    }

    /* Enhanced responsive design */
    
    /* Large screens (desktop) */
    @media (min-width: 1024px) {
      .gallery-grid {
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 24px !important;
      }
    }

    /* Medium screens (tablets) */
    @media (max-width: 1024px) and (min-width: 768px) {
      .gallery-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 20px !important;
      }
    }

    /* Small screens (mobile landscape) */
    @media (max-width: 768px) and (min-width: 480px) {
      .gallery-grid {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 16px !important;
      }
      
      /* Adjust hero section for mobile */
      .hero-content h1 {
        font-size: 2rem !important;
      }
      .hero-content p {
        font-size: 1rem !important;
      }
    }

    /* Extra small screens (mobile portrait) */
    @media (max-width: 480px) {
      .gallery-grid {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }
      
      /* Mobile-specific adjustments */
      .gallery-container {
        padding: 0 12px 48px !important;
      }
      
      .hero-content {
        padding: 0 12px !important;
      }
      
      .hero-content h1 {
        font-size: 1.75rem !important;
      }
      
      .hero-content p {
        font-size: 0.95rem !important;
      }
      
      .badge {
        padding: 6px 12px !important;
      }
      
      .badge span {
        font-size: 12px !important;
      }
      
      /* Modal adjustments for mobile */
      .modal-content {
        padding: 8px !important;
        max-height: 95vh !important;
      }
      
      .close-button {
        top: 8px !important;
        right: 8px !important;
        padding: 6px !important;
        font-size: 20px !important;
      }
      
      .nav-button {
        padding: 8px !important;
        font-size: 20px !important;
      }
      
      .nav-button[style*="left"] {
        left: 8px !important;
      }
      
      .nav-button[style*="right"] {
        right: 8px !important;
      }
      
      .modal-info {
        bottom: 8px !important;
        left: 8px !important;
        right: 8px !important;
        padding: 12px !important;
      }
      
      .modal-info-content {
        flex-direction: column !important;
        gap: 8px !important;
        text-align: center !important;
      }
      
      .image-counter {
        font-size: 12px !important;
      }
      
      .modal-action-button {
        padding: 6px !important;
        font-size: 18px !important;
      }
      
      /* Touch-friendly overlay on mobile */
      .gallery-item .overlay {
        opacity: 0.8 !important;
      }
      
      .gallery-item:active .overlay {
        opacity: 1 !important;
      }
    }

    /* Very small screens */
    @media (max-width: 320px) {
      .gallery-container {
        padding: 0 8px 32px !important;
      }
      
      .hero-content {
        padding: 0 8px !important;
      }
      
      .hero-content h1 {
        font-size: 1.5rem !important;
      }
      
      .hero-content p {
        font-size: 0.9rem !important;
      }
    }

    /* Landscape orientation on mobile */
    @media (max-height: 500px) and (orientation: landscape) {
      .hero {
        padding: 40px 16px 24px !important;
      }
      
      .hero-content h1 {
        font-size: 1.5rem !important;
        margin-bottom: 8px !important;
      }
      
      .hero-content p {
        font-size: 0.9rem !important;
      }
      
      .modal-content {
        max-height: 98vh !important;
      }
    }
  </style>
`;

export default Gallery;